export const menu = [
  {
    displayName: 'Service',
    path: '/atelier-service'
  },
  {
    displayName: 'Trauringschmiedekurs',
    path: '/atelier-service/trauringschmiedekurs'
  },
  {
    displayName: 'Umarbeitung',
    path: '/atelier-service/umarbeitung'
  },
  {
    displayName: 'Ehrensilber',
    path: '/atelier-service/ehrensilber'
  }
];